export const Prices = [
  {
    _id: 0,
    name: "₹0 to 100",
    array: [0, 100],
  },
  {
    _id: 1,
    name: "₹100 to 1000",
    array: [100, 1000],
  },
  {
    _id: 2,
    name: "₹1000 to 10000",
    array: [1000, 10000],
  },
  {
    _id: 3,
    name: "₹10000 to 50000",
    array: [10000, 50000],
  },
  {
    _id: 4,
    name: "₹50000 to 99999",
    array: [50000, 99999],
  },
  {
    _id: 4,
    name: "₹100000 or more",
    array: [100000, 9999999],
  },
];
